export default __webpack_public_path__ + "img/c097fbb3f9242a4ebce8d72f37dff7aa.png";